import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col, Form, Table, Button } from "react-bootstrap";
import { apiGet, apiPost } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import ReactPaginate from "react-paginate";
import { startCase } from "lodash";
import obj from "../utils/helpers";
import PreviewImage from "../components/PreviewImage";
import helpers from "../utils/helpers";
import moment from "moment";
import UpdateDialogBox from "../components/UpdateDialogBox";
import AuthContext from "../context/AuthContext";
import { toast } from "wc-toast";

const PendingDeposit = () => {
  let { user, setBellSound } = useContext(AuthContext);

  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [pageCount, setPageCount] = useState(0);
  const [viewpage, setViewPage] = useState(0);
  const [loader, setLoader] = useState(false);
  const [filter, setFilter] = useState({
    startDate: previousDate,
    endDate: currentDate,
    filterByDay: "",
    page: 1,
    limit: 100,
    keyword: "",
    status:"requested"
  });
  const [show, setShow] = useState({
    status: false,
    image: "",
  });
  const getData = async (obj = filter) => {
    setLoader(true);
    if (obj.filterByDay != "") {
      if (obj.filterByDay == "today") {
        obj.startDate = currentDate;
        obj.endDate = currentDate;
      }
      if (obj.filterByDay == "yesterday") {
        obj.startDate = previousDate;
        obj.endDate = currentDate;
      }
    }
    const { status, data: response_users } = await apiPost(
      apiPath.depositRequest,
      obj
    );
    if (status === 200) {
      if (response_users.success) {
        setData(response_users?.results);
        setPageCount(response_users?.results?.totalPages);
        setLoader(false);
      } else {
        setLoader(false);
      }
    } else {
      setLoader(false);
    }
  };

  const handlePageClick = (event) => {
    let obj = {
      ...filter,
      page: event.selected + 1,
      limit: filter?.limit,
      startDate: filter?.startDate,
      endDate: filter?.endDate,
      keyword: filter?.keyword,
      status: filter?.status,
    };
    setFilter(obj);
    getData(obj);
  };

  useEffect(() => {
    getData();
  }, []);
  const updateTransaction = async (obj) => {
    setLoader(true);
    const { status, data: response_users } = await apiPost(
      apiPath.updateRequestStatus,
      {
        TransactionRequestId: open?.id?._id,
        status: open?.typeCheck,
        type: "deposit",
        remark: obj?.remark,
      }
    );
    if (status === 200) {
      if (response_users.success) {
        setLoader(false);
        toast.success(response_users?.message);
        setOpen({});
        getData();
      } else {
        toast.error(response_users?.message);
        setLoader(false);
      }
    } else {
      toast.error(response_users?.message);
      setLoader(false);
    }
  };
  return (
    <div>
      <section className="main-inner-outer py-4">
        <Container fluid>
          <div className="db-sec">
            <h2 className="common-heading">Pending Deposit</h2>
          </div>
          <div className="inner-wrapper">
            <div className="common-container">
              {" "}

              <div className="bet_status mb-0">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Form.Group
                    style={{ marginRight: "10px" }}
                    className="position-relative"
                  >
                    <Form.Control
                      style={{ height: "1.7rem" }}
                      type="text"
                      placeholder="Keyword"
                      value={filter?.keyword}
                      onChange={(e) =>
                        setFilter({
                          ...filter,
                          keyword: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                  <Form.Group
                    style={{ marginRight: "10px" }}
                    className="position-relative d-flex align-items-center"
                  >
                    <Form.Select

                      className="small_select"
                      onChange={(e) =>
                        setFilter({ ...filter, status: e.target.value })
                      }
                      value={filter.status}
                      aria-label="Default select example"
                    >
                      <option value="">Select Status</option>
                      <option value="approve">Approve</option>
                      <option value="decline">Decline</option>
                    </Form.Select>
                  </Form.Group>
                  <div
                    style={{ marginRight: "10px" }}
                    className="bet-sec bet-period"
                  >
                    <Form.Label className="mt-2 me-2">From</Form.Label>
                    <Form.Group className="form-group">
                      <Form.Control
                        className="small_form_control"
                        onChange={(e) =>
                          setFilter({
                            ...filter,
                            startDate: e.target.value,
                            filterByDay: "",
                          })
                        }
                        max={new Date().toISOString().split("T")[0]}
                        value={filter.startDate}
                        type="date"
                      />

                    </Form.Group>
                  </div>
                  <div
                    style={{ marginRight: "10px" }}
                    className="bet-sec bet-period"
                  >
                    <Form.Label className="mt-2 me-2">To</Form.Label>
                    <Form.Group className="form-group">
                      <Form.Control
                        className="small_form_control"
                        onChange={(e) =>
                          setFilter({
                            ...filter,
                            endDate: e.target.value,
                            filterByDay: "",
                          })
                        }
                        min={
                          filter?.fromPeriod
                            ? new Date(filter?.fromPeriod)
                              .toISOString()
                              .split("T")[0]
                            : new Date()
                        }
                        max={new Date().toISOString().split("T")[0]}
                        value={filter.endDate}
                        type="date"
                      />

                    </Form.Group>
                  </div>{" "}
                </div>{" "}
                <div className="history-btn mt-2">
                  <ul className="list-unstyled mb-0 d-flex">
                    <li style={{ marginRight: "15px" }}>
                      <Button
                        className={"me-0 theme_light_btn"}
                        onClick={(e) =>
                          setFilter({
                            ...filter,
                            filterByDay: "today",
                            startDate: currentDate,
                            endDate: currentDate,
                          })
                        }
                      >
                        Just For Today
                      </Button>
                    </li>
                    <li>
                      <Button
                        className={"me-0 theme_light_btn"}
                        onClick={(e) =>
                          setFilter({
                            ...filter,
                            filterByDay: "yesterday",
                            startDate: previousDate,
                            endDate: currentDate,
                          })
                        }
                      >
                        From Yesterday
                      </Button>
                    </li>

                    <li>
                      <Button
                        style={{ marginRight: "0" }}
                        className="theme_light_btn theme_dark_btn"
                        onClick={() => getData(filter)}
                      >
                        Search
                      </Button>
                    </li>
                    <li>
                      <Button
                        className="theme_light_btn"
                        onClick={() => {
                          setFilter({
                            startDate: previousDate,
                            endDate: currentDate,
                            filterByDay: "",
                            page: 1,
                            limit: 10,
                            keyword: "",
                            status: "",
                          });
                          getData({
                            startDate: previousDate,
                            endDate: currentDate,
                            filterByDay: "",
                            page: 1,
                            limit: 10,
                            keyword: "",
                            status: "",
                          });
                        }}
                      >
                        Reset
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>

              {/* <section className="total-balance-sec was">
                <Container fluid className="px-0">
                  <ul className="list-unstyled">
                    <li>
                      <dt>Approve Deposit Amount</dt>
                      <strong>
                        BDT {`${obj.currencyFormat(data?.totalApproveAmount)}`}
                      </strong>
                    </li>
                    <li>
                      <dt>Decline Deposit Amount</dt>
                      <strong>
                        BDT {`${obj.currencyFormat(data?.totalDeclineAmount)}`}
                      </strong>
                    </li>
                  </ul>
                </Container>
              </section> */}
              <div className="account-table batting-table">
                <div className="responsive">
                  <Table>
                    <thead>
                      <tr>
                        <th scope="col">Sr no.</th>
                        <th scope="col">Username</th>
                        <th scope="col">Order No.</th>
                        <th scope="col">Transaction ID</th>
                       
                        <th scope="col">Bank Name</th>
                        {/* <th scope="col">Bank Account</th> */}
                        <th scope="col">Amount</th>
                        <th scope="col">Transaction Type</th>
                        {/* <th scope="col">Transaction File</th> */}
                        <th scope="col">Created Date</th>
                        <th scope="col">Status</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    {data?.data && data?.data?.length > 0 ? (
                      data?.data?.map((item, index) => {
                        return (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{item?.username || item?.userId}</td>
                            <td>{item?.RequestId}</td>
                            <td>{item?.TransactionId}</td>
                            
                            <td>{item?.transactionType}</td>
                            {/* <td>{item?.BankAccount || "-"}</td> */}
                            <td>{item?.amount}</td>
                            <td>{startCase(item?.type) || "-"}</td>
                            {/* <td className="p-0 m-0">
                              {item?.TransactionFile?.split("/")?.length > 1 ? (
                                <img
                                  style={{
                                    width: "120px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                  onClick={() => {
                                    setShow({
                                      status: true,
                                      image:
                                        process.env.REACT_APP_API_BASE_URL +
                                        item?.TransactionFile,
                                    });
                                  }}
                                  src={
                                    process.env.REACT_APP_API_BASE_URL +
                                    item?.TransactionFile
                                  }
                                />
                              ) : (
                                "-"
                              )}
                            </td> */}
                            <td>
                              {
                                item?.createdAt
                                // moment(item?.createdAt).format("DD-MM-YYYY, h:mm:ss A")
                                // obj?.dateFormat()}
                              }
                            </td>
                            <td>
                              {/* {item?.status == "completed"
                                ? "Approve"
                                : "Decline"} */}
                                 {item?.status}
                            </td>
                            <td>
                             {item?.status == "requested"?
                                  <>
                                    <Button
                                      className="btn btn-primary"
                                      style={{ background: "green", color: "white" }}
                                      onClick={() =>
                                        setOpen({
                                          status: true,
                                          type: "approve",
                                          typeCheck: "completed",
                                          id: item,
                                        })
                                      }
                                    >
                                      Approve
                                    </Button>
                                    {/* <Button
                                      className="btn btn-danger"
                                      style={{ background: "red", color: "white" }}
                                      onClick={() =>
                                        setOpen({
                                          status: true,
                                          type: "decline",
                                          typeCheck: "voided",
                                          id: item,
                                        })
                                      }
                                    >
                                      Decline
                                    </Button> */}
                                    </>
                                :""}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={12}>
                          <span>No Record Found.</span>
                        </td>
                      </tr>
                    )}
                  </Table>
                </div>
                {(data?.hasNextPage || data?.hasPrevPage) && (
                  <div className="bottom-pagination">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel=" >"
                      forcePage={viewpage}
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={10}
                      pageCount={pageCount}
                      previousLabel="< "
                      renderOnZeroPageCount={null}
                      activeClassName="p-1"
                      activeLinkClassName="pagintion-li"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Container>
      </section>
      {show?.status && (
        <PreviewImage
          onClose={() => setShow({ status: false, image: "" })}
          open={show?.status}
          image={show?.image}
        />
      )}
      {open?.status && (
        <UpdateDialogBox
          open={open?.status}
          type={"deposit"}
          item={open?.id}
          onClose={() => setOpen({ status: false, type: "" })}
          onSubmit={updateTransaction}
          headerTitle={startCase(open?.type)}
          title={`Do you want to ${open?.type} this transaction`}
          isLoader={loader}
        />
      )}
    </div>
  );
};

export default PendingDeposit;
